<template>
  <q-page>
    <div class="pageContent">  
      
      <div class="row">
        <q-card class="col-12 chart">
          <q-card-section class="text-weight-bold">
            {{$t("global.FleetStatus")}}
          </q-card-section>
          <q-card-section>
            <GChart
              v-if="statusChartDataGauge"
              :settings="{ packages: ['corechart', 'table', 'map','gauge'] }"
              type="Gauge"
              :data="statusChartDataGauge"
              :options="statusChartOptionGauge"
            />
          </q-card-section>
        </q-card>
      </div>

      <div class="row">
        <q-card class="col-12 chart">
          <q-card-section class="text-weight-bold">
           {{$t("global.Distance24Hours")}}
            <q-toggle class="float-right"
            v-model="groupD24"
            :label="this.$t('global.UnitGroup')"
            left-label
          />
          </q-card-section>
          <q-card-section>
            <GChart
              :settings="{ packages: ['corechart', 'table', 'map'] }"
              type="ColumnChart"
              :data="distanceGroupData"
              :options="distanceChartOption"
            />
          </q-card-section>
        </q-card>
      </div>

      <div class="row">
        <q-card class="col-12 chart">
          <q-card-section class="text-weight-bold">
            {{$t("global.Alerts24Hours")}}
            <q-toggle class="float-right"
            v-model="groupA24"
            :label="this.$t('global.UnitGroup')"
            left-label
          />
          </q-card-section>
          <q-card-section>
            <GChart v-if="alertChartDataNew.length > 1"
              :settings="{ packages: ['corechart', 'table', 'map'] }"
              type="ColumnChart"
              :data="alertChartDataNew"
              :options="alertChartOption"
            />
          </q-card-section>
        </q-card>
      </div>

      <div class="row">
        <q-card class="col-12 chart">
          <q-card-section class="text-weight-bold">
            {{$t("global.VehicleMaintenanceStatus")}}
          </q-card-section>
          <q-card-section>
            <p class="text-weight-bold">{{$t("global.TimeBased")}}</p>
            <GChart v-if="maintenanceDataDayNew.length > 1"
              :settings="{ packages: ['corechart', 'table', 'treemap', 'timeline'], language: 'us' }"
              type="Timeline"
              :data="maintenanceDataDayNew"
              :options="maintenaceChartOptionsDay"
            />
            <p class="text-weight-bold">{{$t("global.DistanceBased")}}</p>
            <GChart v-if="maintenanceDataDistanceNew.length > 1"
              :settings="{ packages: ['corechart', 'table', 'map'] }"
              type="ColumnChart"
              :data="maintenanceDataDistanceNew"
              :options="maintenaceChartOptionsDistance"
            />
          </q-card-section>
        </q-card>
      </div>

    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import { GChart } from 'vue-google-charts'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'User',
  data: function () {
    return {
      interval: null,
      dataLoaded: false,
      form: {},
      groupA24: true,
      groupD24: true,
      statusChartDataGauge: [],
      statusChartOptionGauge: {},
      maintenanceDataDay: [],
      maintenanceDataDayNew: [],
      maintenaceChartOptionsDay: { height: 230 },
      alertChartDataNew: [],
      alertChartOption: {
        vAxis: {title: 'Alerts'},
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '75%' },
        isStacked: true
      },
      distanceGroupData: [],
      distanceChartOption: {
        vAxis: {title: 'KM'},
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '75%' },
      },

      maintenanceDataDistance: [],
      maintenanceDataDistanceNew: [],
      maintenaceChartOptionsDistance: {
        vAxis: {title: this.$t("global.MaintenanceSchedule")},
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '75%' },
        isStacked: true,
        series: {
          0:{color:'#DC3912'},
          1:{color:'#990099'},
          2:{color:'#FF9900'},
          3:{color:'#22AA99'},
          4:{color:'#0099C6'},
          5:{color:'#AAAA11'},
          6:{color:'#329262'}
        
        }
      },
      
    }
  },
  methods: {
    getData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetData"
      this.form.GroupA24 = this.groupA24
      this.form.GroupD24 = this.groupD24
      axios.post(this.$apiUrlGo + "/dashboard/",
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            //Set group or unit, the first time
            if(this.dataLoaded == false){
              if(response.data.Distance24.length == 1){
              this.groupA24 = false
              this.groupD24 = false 
              }
            }
            this.dataLoaded = true
            //--------------F-l-e-e-t--S-t-a-t-u-s------------------------
              this.fleetStatus = response.data.FleetStatus[0]
              this.statusChartOptionGauge = { max: this.fleetStatus.TotalDev }
              this.statusChartDataGauge = [
                ['Label', 'Value'],
                [this.$t("global.Moving"),  this.fleetStatus.Moving],
                [this.$t("global.Idle"),  this.fleetStatus.Idle],
                [this.$t("global.Stopped"),  this.fleetStatus.Stop],
                [this.$t("global.NotActive"), this.fleetStatus.NotActive],
                [this.$t("global.NotActive3Day"), this.fleetStatus.NotActive3D]
              ]
              
              //------------D-i-s-t-s-a-n-c-e--24------------
              let title = []
              let data = []
              let series = []
              title.push('Date')
              data.push(this.moment().format(this.$store.state.session.DateTimeFormat))                
              
              response.data.Distance24.forEach(groupUnit => {
                console.log(groupUnit)
                title.push(groupUnit.UnitGroup)
                data.push(groupUnit.Distance)
              }) 
              
              this.distanceGroupData = []
              this.distanceGroupData.push(title)
              this.distanceGroupData.push(data)     
              //-----------A-l-e-r-t--24--------------------------
              this.alertChartDataNew = []
              let trackingGroups = {}
              let alerts = {}
              title = []
              data = []
              
              let alert24 = response.data.Alert24
              var i;
              for (i = 0; i < alert24.length; i++) {
                var a = alert24[i]
                alerts[a.AlertConfigID] = a.AlertConfigName
                trackingGroups[a.TrackingGroupID] = a.UnitGroup
              }
              
              title.push('TrackingGroup')
              for (var item in trackingGroups) {
                console.log('key:' + item + ' value:' + trackingGroups[item]);
                title.push(trackingGroups[item])
              }
              this.alertChartDataNew.push(title)
              let dline = []
              for (var alertConfigID in alerts) {
                dline.push(alerts[alertConfigID])
                for (var trackingGroupID in trackingGroups) {
                  var cnr = 0
                  for (i = 0; i < alert24.length; i++) {
                    var a = alert24[i]
                    if(a.AlertConfigID == alertConfigID  && a.TrackingGroupID == trackingGroupID){
                      cnr = a.Count
                    }
                  }
                  dline.push(cnr)
                }
                this.alertChartDataNew.push(dline)
                dline = []
              }
              //-----------------MaintenanceDataDay---------------------------
              this.maintenanceDataDayNew = []
              this.maintenanceDataDayNew.push([{ type: 'string', id: 'Schedule' }, { type: 'string', id: 'Count' }, { type: 'string', role: 'style' }, { type: 'string', role: 'tooltip' },  { type: 'date', id: 'Start' }, { type: 'date', id: 'End' }])
              let schedules = {}
              response.data.MaintenanceDataDay.forEach(maintenanceDataDay => {
                schedules[maintenanceDataDay.Schedule] = maintenanceDataDay.Schedule
                var start = this.moment(maintenanceDataDay.Start)
                var due = this.moment(maintenanceDataDay.Start).add(maintenanceDataDay.Days, 'days')
                //var dueEnd = due.add(5, 'days')
                var dueEnd = this.moment(maintenanceDataDay.Start).add(maintenanceDataDay.Days + 5, 'days')
                var color = '#00ff00'
                if(this.moment(due).isBefore()){
                  color = '#ff0000'
                }
                var tip = '<div id="timeline-tooltip" style=" width: 260px; padding: 10px;">'
                tip += this.$t('global.MaintenanceSchedule') + ': <b>' + maintenanceDataDay.Schedule + '</b><br>'
                tip += this.$t('global.DueDay') + ': <b>' + due.format(this.$store.state.session.DateFormat) + '</b><br>'
                tip += this.$t('global.NumberOfUnits') +': <b>' + maintenanceDataDay.Count + '</b><br>'

                tip += '</div>'
                this.maintenanceDataDayNew.push([maintenanceDataDay.Schedule, maintenanceDataDay.Count, color, tip, due.toDate(), dueEnd.toDate()])
              })
              
              //calculate and set height of chart
              let height = 150
              height = height + (Object.keys(schedules).length * 10)
              this.maintenaceChartOptionsDay = { height: height }   
              
              //-----------------MaintenanceDataDistance---------------------------
              data = []
              data.push(['Distance Group', this.$t('global.OverDue'), '0 - 100 Km', '100 - 500 Km', '500 - 1000 Km', '1000 - 5000 Km', '5000 - 20000 Km', '> 20000 Km'])
              response.data.MaintenanceDataDistance.forEach(md => {
                var dataRow = [md.Schedule, md.OverDue, md.G100, md.G500, md.G1000, md.G5000, md.G20000, md.G20000Plus ]
                data.push(dataRow)          
              }) 
              this.maintenanceDataDistanceNew = data
              //-------------------------------------------------------------------
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }

  },
  components: {
    GChart
  },
  mounted() { 
    this.maintenanceDataDay.push(["Schedule", "Count", "From Date", "To Date"]);
    this.maintenanceDataDay.push(["Oil Change", "5", new Date("2020-06-01"), new Date("2020-06-02")]);
    this.maintenanceDataDay.push(["General Service","77", new Date("2020-07-01"), new Date("2020-07-02")]);
    this.maintenanceDataDay.push(["Renew License","13", new Date("2022-08-01"), new Date("2022-08-02")]);
    this.getData()
    this.interval = setInterval(() => {
        this.getData()
    }, 30000)
  },  
   computed:{
     
   },

   watch: {
    groupD24: function (val) {     
      this.getData()
    },
    groupA24: function (val) {     
      this.getData()
    },
    
  },

  beforeDestroy(){
    clearInterval(this.interval)
  }
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>
<style scoped>
.content{
  padding: 5px;
}
.pageContent{
  padding: 10px;
}
.chart{
  width: 100%;
}
.row{
  padding: 10px;
}
</style>
